import { FulfillmentOrderRouteService } from 'common/data';
import { findParams } from 'core/utils';
import { BaseService } from 'core/services';

class FulfillmentOrderService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new FulfillmentOrderRouteService());
	}

	find(filter) {
		const url = this.routeService.find(filter);
		return this.apiClient.post(url, findParams(filter));
	}

	select(filter) {
		const url = this.routeService.select(filter);
		return this.apiClient.post(url, findParams(filter));
	}

	getCloseoutOrders(filter) {
		const url = this.routeService.getCloseoutOrders(filter);
		return this.apiClient.post(url, findParams(filter));
	}

	splitFulfillmentOrder = (fulfillmentOrders, sourceOfChange) => {
		const url = this.routeService.splitFulfillmentOrder(sourceOfChange);
		return this.apiClient.post(url, fulfillmentOrders);
	};

	editFulfillmentOrderSplit = (fulfillmentOrders, sourceOfChange) => {
		const url = this.routeService.editFulfillmentOrderSplit(sourceOfChange);
		return this.apiClient.post(url, fulfillmentOrders);
	};

	toggleProductionMode(id, productionMode, sourceOfChange) {
		const url = this.routeService.toggleProductionMode(id, productionMode, sourceOfChange);
		return this.apiClient.put(url);
	}

	getFulfillmentOrdersForLabeling = filter => {
		const url = this.routeService.getFulfillmentOrdersForLabeling(filter);
		return this.apiClient.post(url, findParams(filter));
	};

	getFulfillmentOrderShipment = (upc, sourceOfChange) => {
		const url = this.routeService.getFulfillmentOrderShipment(upc, sourceOfChange);
		return this.apiClient.get(url);
	};

	countFulfillmentOrdersByStatus(filter) {
		const url = this.routeService.countFulfillmentOrdersByStatus(filter);
		return this.apiClient.post(url, findParams(filter));
	}

	updateBuyShippingBulk(items, sourceOfChange) {
		const url = this.routeService.updateBuyShippingBulk(items, sourceOfChange);
		return this.apiClient.put(url, items);
	}

	assignCarrierServiceAndWarehouse(data, sourceOfChange) {
		const url = this.routeService.assignCarrierServiceAndWarehouse(data, sourceOfChange);
		return this.apiClient.put(url, data);
	}

	assignCarrierServiceAndWarehouseBulk(data, sourceOfChange) {
		const url = this.routeService.assignCarrierServiceAndWarehouseBulk(data, sourceOfChange);
		return this.apiClient.put(url, data);
	}

	changeShipping(changeShippingParams, sourceOfChange) {
		const url = this.routeService.changeShipping(changeShippingParams, sourceOfChange);
		return this.apiClient.post(url, changeShippingParams);
	}

	changeShippingBulk(changeShippingBulkParams, sourceOfChange) {
		const url = this.routeService.changeShippingBulk(changeShippingBulkParams, sourceOfChange);
		return this.apiClient.post(url, changeShippingBulkParams);
	}

	collectFulfillmentOrdermItem(item) {
		const url = this.routeService.collectFulfillmentOrdermItem(item);
		return this.apiClient.put(url);
	}

	cancelFulfillmentOrder(item, sourceOfChange) {
		const url = this.routeService.cancelFulfillmentOrder(item, sourceOfChange);
		return this.apiClient.put(url);
	}

	scanLabel(resource, sourceOfChange) {
		const url = this.routeService.scanLabel(resource, sourceOfChange);
		return this.apiClient.put(url, resource);
	}

	neverShipped(neverShippedParams, sourceOfChange) {
		var url = this.routeService.neverShipped(neverShippedParams, sourceOfChange);
		return this.apiClient.post(url, neverShippedParams);
	}

	neverShippedBulk(neverShippedBulkParams, voidOnChannel, sourceOfChange) {
		var url = this.routeService.neverShippedBulk(neverShippedBulkParams, voidOnChannel, sourceOfChange);
		return this.apiClient.post(url, neverShippedBulkParams);
	}

	track(trackingParams) {
		const url = this.routeService.track(trackingParams);
		return this.apiClient.post(url, findParams(trackingParams));
	}

	statusChange(statusChangeParams, sourceOfChange) {
		const url = this.routeService.statusChange(statusChangeParams, sourceOfChange);
		return this.apiClient.post(url, statusChangeParams);
	}

	onHold(onHoldParams, sourceOfChange) {
		const url = this.routeService.onHold(onHoldParams, sourceOfChange);
		return this.apiClient.post(url, onHoldParams);
	}

	onHoldBulk(onHoldBulkParams, sourceOfChange) {
		const url = this.routeService.onHoldBulk(onHoldBulkParams, sourceOfChange);
		return this.apiClient.post(url, onHoldBulkParams);
	}

	markAsShipped(markAsShippedParams, sourceOfChange) {
		const url = this.routeService.markAsShipped(markAsShippedParams, sourceOfChange);
		return this.apiClient.put(url, markAsShippedParams);
	}

	markAsShippedBulk(markAsShippedBulkParams, sourceOfChange) {
		const url = this.routeService.markAsShippedBulk(markAsShippedBulkParams, sourceOfChange);
		return this.apiClient.put(url, markAsShippedBulkParams);
	}

	undoPackaged(undoPackageParams, sourceOfChange) {
		const url = this.routeService.undoPackaged(undoPackageParams, sourceOfChange);
		return this.apiClient.post(url, undoPackageParams);
	}

	abortLabelingMode(abortLabelingParams, sourceOfChange) {
		const url = this.routeService.abortLabelingMode(abortLabelingParams, sourceOfChange);
		return this.apiClient.post(url, abortLabelingParams);
	}

	createWarehouseOrders(fulfillmentOrderIds) {
		const url = this.routeService.createWarehouseOrders(fulfillmentOrderIds);
		return this.apiClient.post(url, fulfillmentOrderIds);
	}

	splitFulfillmentOrderLabelingMode(splitFulfillmentOrderParams, sourceOfChange) {
		const url = this.routeService.splitFulfillmentOrderLabelingMode(splitFulfillmentOrderParams, sourceOfChange);
		return this.apiClient.post(url, splitFulfillmentOrderParams);
	}

	updateFulfillmentOrderInfo(order, sourceOfChange) {
		var url = this.routeService.updateFulfillmentOrderInfo(order, sourceOfChange);
		return this.apiClient.put(url, order);
	}

	validateOrderAddress(order) {
		var url = this.routeService.validateOrderAddress(order);
		return this.apiClient.put(url, order);
	}

	reoptimize(reoptimizeParams, sourceOfChange) {
		const url = this.routeService.reoptimize(sourceOfChange);
		return this.apiClient.post(url, reoptimizeParams);
	}
}

export default FulfillmentOrderService;



// WEBPACK FOOTER //
// ./src/common/data/services/FulfillmentOrderService.js